import { render, staticRenderFns } from "./tab-success.vue?vue&type=template&id=450b138f&"
import script from "./tab-success.vue?vue&type=script&lang=js&"
export * from "./tab-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports